import React from 'react'

const Manual_invupos_reimpresion_ordenes = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          InvuPOS - Reimpresión de Órdenes No Facturadas
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía explica cómo reimprimir órdenes no facturadas de manera sencilla, asegurando una correcta gestión de pedidos y optimizando el flujo de trabajo en InvuPOS.
        </p>
        <iframe
          src="https://scribehow.com/embed/InvuPOS__Reimpresion_de_Ordenes_No_Facturadas__nFi8fc3YTrqxwTclpVb7RQ?as=scrollable"
          className="scribe-iframe-general-56"
          width="100%"
          height="4860"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_invupos_reimpresion_ordenes